// extracted by css-extract-rspack-plugin
export default {"textButton":"header-fragment__LinkMenuItem_textButton__2Uewl"};